export const NAVIGATE_TO_THREAD = 'NAVIGATE_TO_THREAD';
export const NAVIGATE_TO_INBOX = 'NAVIGATE_TO_INBOX';